"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateSEOData = exports.defaultSEOData = exports.countrySEOData = exports.citySEOData = exports.brokerageSEOData = exports.agentSEOData = exports.agencySEOData = void 0;
var agentSEOData = props => {
  return {
    title: "".concat(props.name, " - Financial Professional in ").concat(props.location.city, ", ").concat(props.location.state, " | MassMutual"),
    titleOG: "".concat(props.name, "| MassMutual"),
    description: "".concat(props.name, " offers personalized retirement, insurance, and financial advice in ").concat(props.location.city, ", ").concat(props.location.stateName, ". Secure your future with MassMutual."),
    descriptionOG: "Get information about ".concat(props.name, ", a MassMutual Financial Professional in ").concat(props.location.city, ", ").concat(props.location.stateName, ". Find contact information, expertise and more, to start your path to the right coverage and planning for your future."),
    city: true,
    state: true,
    country: true
  };
};
exports.agentSEOData = agentSEOData;
var agencySEOData = props => {
  return {
    title: "".concat(props.name, " | Financial Professionals at MassMutual"),
    titleOG: "Find a MassMutual Financial Professional in ".concat(props.location.city, ", ").concat(props.location.state, " | MassMutual"),
    description: "Find a MassMutual Financial Professional at ".concat(props.name, " in ").concat(props.location.city, ", ").concat(props.location.stateName, " to help you learn more about insurance, investing and financial planning."),
    descriptionOG: "MassMutual's Financial Professionals at ".concat(props.name, " in ").concat(props.location.city, ", ").concat(props.location.stateName, " can help you learn more about insurance, investing and financial planning. Find a Financial Professional to learn more, get coverage or get a quote."),
    city: true,
    state: true,
    country: true
  };
};
exports.agencySEOData = agencySEOData;
var citySEOData = props => {
  return {
    title: "".concat(props.location.city, ", ").concat(props.location.stateName, " | Financial Professionals at MassMutual"),
    titleOG: "Find a MassMutual Financial Professional in ".concat(props.location.city, ", ").concat(props.location.state, " | MassMutual"),
    description: "Find a MassMutual Financial Professional in ".concat(props.location.city, ", ").concat(props.location.stateName, " to help you learn more about insurance, investing and financial planning."),
    descriptionOG: "MassMutual's Financial Professionals in ".concat(props.location.city, ", ").concat(props.location.stateName, " can help you learn more about insurance, investing and financial planning. Find a Financial Professional to learn more, get coverage or get a quote."),
    city: true,
    state: true,
    country: true
  };
};
exports.citySEOData = citySEOData;
var stateSEOData = props => {
  return {
    title: "".concat(props.location.state, ", ").concat(props.location.stateName, " | Financial Professionals at MassMutual"),
    titleOG: "Find a MassMutual Financial Professional in ".concat(props.location.state, ", ").concat(props.location.stateName, " | MassMutual"),
    description: "Find a MassMutual Financial Professional in ".concat(props.location.stateName, " to help you learn more about insurance, investing and financial planning."),
    descriptionOG: "MassMutual's Financial Professionals  ".concat(props.location.stateName, " can help you learn more about insurance, investing and financial planning. Find a Financial Professional to learn more, get coverage or get a quote."),
    city: false,
    state: true,
    country: true
  };
};
exports.stateSEOData = stateSEOData;
var countrySEOData = () => {
  return {
    title: "Select by State | Financial Professionals at MassMutual",
    titleOG: "Find a Financial Professional by State | MassMutual",
    description: "Leverage MassMutual's nationwide network of Financial Professionals to help you learn more about insurance, investing and financial planning",
    descriptionOG: "MassMutual's nationwide network of Financial Professionals can help you learn more about insurance, investing and financial planning. Find a Financial Professional to learn more, get coverage or get a quote.",
    city: false,
    state: false,
    country: true
  };
};
exports.countrySEOData = countrySEOData;
var brokerageSEOData = props => {
  return {
    title: "".concat(props.name, " | MassMutual Brokerage Directors"),
    titleOG: "".concat(props.name, " | MassMutual Brokerage Directors"),
    description: "Contact and information about ".concat(props.name, ", a MassMutual Brokerage Director."),
    descriptionOG: "Contact and information about ".concat(props.name, ", a MassMutual Brokerage Director."),
    city: false,
    state: false,
    country: false
  };
};
exports.brokerageSEOData = brokerageSEOData;
var defaultSEOData = () => {
  return {
    title: "Financial Professionals at MassMutual",
    titleOG: "Find a Financial Professional | MassMutual",
    description: "Leverage MassMutual's nationwide network of Financial Professionals to help you learn more about insurance, investing and financial planning",
    descriptionOG: "MassMutual's nationwide network of Financial Professionals can help you learn more about insurance, investing and financial planning. Find a Financial Professional to learn more, get coverage or get a quote.",
    city: false,
    state: false,
    country: true
  };
};
exports.defaultSEOData = defaultSEOData;